const resourcesApi = ({ apiClient }) => ({
  show() {
    return apiClient.get(`real-estates/resources`)
  },
  store(payload) {
    return apiClient.put(`real-estates/resources`, { resources: { ...payload } })
  },
})

export default resourcesApi
